import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@sizefinder.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-[#141414] border border-[#333] px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-white transition-colors duration-200";

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white tech-grid-bg flex items-center justify-center p-5">
      <div className="w-full max-w-sm bg-[#0A0A0A] border border-[#333] p-8 animate-fade-up">
        <div className="flex items-center gap-2 mb-8">
          <Crown className="w-5 h-5 gold" strokeWidth={1.5} />
          <span className="font-display text-xl uppercase tracking-tight">FitFinder Admin</span>
        </div>
        <span className="overline text-white/40">Sign in</span>
        <h1 className="font-display text-3xl uppercase mt-1 mb-6">Dashboard Access</h1>

        <form onSubmit={submit}>
          <label className="overline text-white/50 block mb-2">Email</label>
          <input
            data-testid="login-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
          />
          <label className="overline text-white/50 block mb-2 mt-4">Password</label>
          <input
            data-testid="login-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            className={inputCls}
          />
          {error && (
            <p className="text-red-400 text-sm mt-4" data-testid="login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="mt-6 w-full bg-white text-black font-bold uppercase tracking-wider py-4 flex items-center justify-center gap-2 hover:bg-gold transition-colors duration-200 active:scale-[0.99] disabled:opacity-60"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
